import React, { ReactElement } from 'react'
let timeinterval: NodeJS.Timeout;

type CountdownProps = {
    children: ReactElement;
    render: (date: string) => {};
    date: number;
};

type CountdownState = {
    completed: boolean;
    date: string;
};

export default class Countdown extends React.Component<CountdownProps, CountdownState> {

    state = {
        completed: false,
        date: '',
    }

    refresh = (total: Date) => () => {
        const t = getTimeRemaining(total);
        this.setState({ date: `${t.minutes}:${t.seconds}` })
        if (t.total <= 0) {
            this.setState({ completed: true });
            clearInterval(timeinterval);
        }
    }

    start = () => {
        const total = new Date(Date.now() + (this.props.date * 1000));
        const t = getTimeRemaining(total);
        this.setState({ completed: false, date: `${t.minutes}:${t.seconds}` })
        if (timeinterval) {
            clearInterval(timeinterval);
        }
        timeinterval = setInterval(this.refresh(total), 1000);
    }



    render(): React.ReactNode {
        return (
            <>
                {
                    this.state.completed ?
                        this.props.children
                        :
                        this.props.render(this.state.date)
                }
            </>
        )
    }
}

function getTimeRemaining(endtime: Date) {
    const total = endtime.getTime() - Date.now();
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
        total,
        days,
        hours,
        minutes,
        seconds
    };
}
